let seed = 1

export const randomFloat = (min = 0, max = 1) => {
    seed = (seed * 9301 + 49297) % 233280
    const random = seed / 233280
 
    return min + random * (max - min)
}

export const randomInt = (...args) => Math.round(randomFloat(...args))



// WEBPACK FOOTER //
// ./src/utils/random.js